module.exports = __webpack_public_path__ + "static/media/tanmay_karad.ec456e4d.png";